import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { Typography } from "@circle-react-uikit/Typography";

interface FloatingActionButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const getButtonStyle = (isHovered: boolean) => ({
  background: "white",
  backgroundImage: isHovered
    ? "linear-gradient(180deg, #506CF1 0%, #0F26A6 100%)"
    : "none",
  border: "1px solid var(--Widget-border, rgba(228, 231, 235, 0.40))",
  boxShadow:
    "0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10)",
  transition: "all 0.2s ease-in-out",
});

export const FloatingActionButton = ({
  isOpen,
  onClick,
}: FloatingActionButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <BlockInViewOnlyMode>
      <button
        type="submit"
        className="float-right mb-px hidden h-11 items-center justify-center gap-2 self-end rounded-3xl px-4 py-3 lg:flex"
        style={getButtonStyle(isHovered)}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label={t("support_widget.floating_button_aria_label")}
        aria-expanded={isOpen}
        aria-controls="support-widget"
      >
        <div className="relative">
          <svg
            className="icon icon-hw-fab-default duration-400 transition-opacity ease-in-out"
            style={{ opacity: isHovered ? 0 : 1 }}
            aria-hidden="true"
            viewBox="0 0 18 16"
          >
            <use xlinkHref="#icon-hw-fab-default" />
          </svg>
          <svg
            className="icon icon-hw-fab-hover duration-400 absolute inset-0 transition-opacity ease-in-out"
            style={{ opacity: isHovered ? 1 : 0 }}
            aria-hidden="true"
            viewBox="0 0 18 16"
          >
            <use xlinkHref="#icon-hw-fab-hover" />
          </svg>
        </div>
        <div className="duration-400 transition-colors ease-in-out">
          <Typography.BodySm
            color={isHovered ? "text-white" : "text-dark"}
            weight="font-semibold"
          >
            {t("help_widget.need_help_fab")}
          </Typography.BodySm>
        </div>
      </button>
    </BlockInViewOnlyMode>
  );
};
